import { render, staticRenderFns } from "./EditPublicationDetail.vue?vue&type=template&id=01b3b83d&scoped=true"
import script from "./EditPublicationDetail.vue?vue&type=script&lang=js"
export * from "./EditPublicationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b3b83d",
  null
  
)

export default component.exports